import {
  IconError,
  IconClock,
  IconSuccess,
} from '../../shared/components/icons';

/**
 * One message row on the panel's own surface, above the action — never a toast.
 * A toast that has gone is a failure a user (screen-reader or not) cannot go
 * back and read; this is `role="alert"`, stays put, and never prints a raw
 * server string. auth.md § States.
 */
const GLYPHS = {
  error: IconError,
  warn: IconClock,
  ok: IconSuccess,
};

const AuthMessage = ({ variant = "error", title, children }) => {
  const Glyph = GLYPHS[variant] || GLYPHS.error;
  return (
    <div className={`lms-auth__msg lms-auth__msg--${variant}`} role="alert">
      <span className="lms-auth__msg-glyph">
        <Glyph style={{ fontSize: 20 }} />
      </span>
      <span className="lms-auth__msg-body">
        {title && <b>{title}</b>}
        {children}
      </span>
    </div>
  );
};

export default AuthMessage;
